 

     <h3 matDialogTitle>Session Expirée</h3>
    <mat-dialog-content>
      <p class="gs1-little">
         Votre session a expiré. Veuillez vous reconnecter. 
     </mat-dialog-content>
    <mat-dialog-actions>
       <button gs1Button cdk-focus-start (click)="login()">Je me connecte</button>
    </mat-dialog-actions>
 